<div class="form-group">
  <label [for]="label">{{label}}</label>
  <input type="email"
         class="form-control"
         [(ngModel)]="value"
         [id]="label">
</div>
